module.exports = __webpack_public_path__ + "static/img/1.6f4575c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/1/zh/1.png
// module id = UP4J
// module chunks = 0